export const defaultImageUrl = '/static/images/image-missing.png'
export const defaultPlaceholderUrl = '/static/images/image-placeholder.png'



// WEBPACK FOOTER //
// ./src/modules/ModuleImage/utils/defaultImages.js